module.exports = __webpack_public_path__ + "static/img/13.96f9626.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/13.jpg
// module id = w07c
// module chunks = 0